import ImageGrid from "./ImageGrid";
import { SectionCardTitle } from "@/components";

const WhyChoose = () => {
  return (
    <div
      className="grid grid-cols-1 lg:grid-cols-2 md:mx-auto px-5 py-10 lg:px-[90px] lg:py-20 lg"
      style={{
        background: "linear-gradient(309.45deg, rgba(0, 167, 89, 0.08) 24.42%, rgba(0, 163, 212, 0.08) 69.56%)",
      }}
    >
      {/* Left Side */}
      <div className="flex items-center justify-center">
        <div className="max-w-[530px]">
          <SectionCardTitle>Why You Should <br/> Choose Intron</SectionCardTitle>
          <br />
          <div className="lg: mt-[20px]">
          <span className="text-[12px] lg:text-[16px] lg:leading-[22px] text-justify text-[16.5px] leading-[28px] text-[#415667]">
            Intron Life Sciences (ILS) is a world class manufacturer of probiotics and other biotech products with a specific focus on poultry, aquaculture and other animal and habitat health along with products for various other applications like bioremediation, agriculture and human health with a commitment to excellence in quality and persistence in research. <br /> <br />

            Our aim is to provide sustainable solutions for sustainable farming in tune with nature. We take pride in our expertise in identification, evaluation, research and the commercialization of probiotics and other biotech products and endeavor to further strengthen and attain leadership position through continuous research and proactively delighting the customer.
          </span>
          </div>
        </div>
      </div>
      {/* Right Side */}
      <img
        src="/img/why-choose-us.png"
        className="mt-[20px] lg:mt-5 lg:!h-[450px] lg:!w-[500px] float-animation"
      />
    </div>
  );
};

export default WhyChoose;
